<div class="app__internal--links app__role--players--card">
  <mat-dialog-content class="mat-dialog-content">
    <mat-accordion class="prevent-click" [@.disabled]="true">
      <mat-expansion-panel
        hideToggle
        [disabled]="true"
        [expanded]="true"
        class="parametersPanel shadow-none rounded-t-none rounded-b-none mt-[-10px]"
        [class]="reminder_list?.length == 0 ? 'relative' : ''"
      >
        <mat-expansion-panel-header class="h-8 disable_ripple">
          <mat-panel-title>
            <div class="app__between--justified--content flex-row w-full">
              <p class="text-base m-0 font-bold text-[#010B18]">
                Checklist @if(reminder_list.length || linkedTasks.length){ ({{ reminder_list.length + linkedTasks.length }}) }
              </p>
              @if(!hideManageButton){
              <button
                class="app__internal--links--add--btn app__centered-item w-fit leading-[34px]"
                [disabled]="isRemoveEditSaveSharing"
                [ngClass]="{ 'hover:cursor-pointer': !isRemoveEditSaveSharing, 'text-[#C1C2C5] hover:cursor-default': isRemoveEditSaveSharing }"
                (click)="!isRemoveEditSaveSharing && createReminder()"
              >
                <span
                  class="material-icons relative text-[16px]"
                  [ngClass]="{ 'text-[#C1C2C5]': isRemoveEditSaveSharing, 'text-[#25508e]': !isRemoveEditSaveSharing }"
                  >settings</span
                >
                <span class="relative"> Manage </span>
              </button>
              }
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="" style="margin: 0 -24px">
          @if ((reminder_list.length || linkedTasks.length) == 0 && !is_loading) {
          <div class="app__centered-item flex-row text-center h-16 border rounded-lg border-[#d3dce8] border-solid mt-[10px]">
            <img src="assets/images/cheecklist-zero-state.svg" />
            <span class="app__form--attribute--title font-semibold text-[12px] ml-2">
              No <span class="font-bold text-[#25508E]"> Items</span> to show
            </span>
          </div>
          } @if ((reminder_list.length || linkedTasks.length) && !is_loading) {
          <div
            style="margin-bottom: 48px; margin: 0 6px"
            [class]="reminder_list.length > 4 ? 'overflow-y-auto max-h-[250px] h-fit' : 'overflow-y-auto max-h-[250px] h-fit'"
            (click)="$event.stopPropagation(); !isRemoveEditSaveSharing && createReminder()"
          >
            @for (items of reminder_list; track items; let i = $index) {
            <div
              class="flex justify-between border rounded border-[#e5e7eb]"
              [ngClass]="resolve_id == items.id ? 'bg-[#EFFFF7] relative overflow-hidden' : ''"
              style="margin: 12px 9px 12px auto"
            >
              <div style="display: flex; margin-left: 6px; max-width: 55%">
                @if(resolve_id == items.id){
                <img src="/assets/gif/confetti-3.gif" alt="" class="w-[100%] absolute left-0" />
                }
                <span style="margin-top: 8px !important">
                  <img src="assets/images/reminder-suggestion-icon.svg" style="height: 32px" />
                </span>
                <p
                  style="padding-left: 6px"
                  class="text-truncate hover:cursor-pointer text-sm font-bold text-[#18191C] m-0 leading-[48px]"
                  [matTooltip]="items.title | reminderTitleName : formValue : items"
                >
                  {{ items.title | reminderTitleName : formValue : items }}
                </p>
              </div>
              <button
                class="m-2 h-8 w-28 rounded"
                [ngClass]="{
                  'hover:cursor-default': isRemoveEditSaveSharing,
                  'bg-[#25508E] text-white hover:cursor-pointer': !isRemoveEditSaveSharing
                }"
                [disabled]="isRemoveEditSaveSharing"
                (click)="$event.stopPropagation(); !isRemoveEditSaveSharing && callAction(items)"
              >
                Resolve
              </button>
            </div>
            }@for (task of linkedTasks; track task; let i = $index) {
            <div class="flex justify-between border rounded border-[#e5e7eb] hover:bg-[#EBF0FA]" style="margin: 12px 9px 12px auto">
              <div style="display: flex; margin-left: 6px; max-width: 55%" (click)="$event.stopPropagation(); editTask(task)">
                <span style="margin-top: 8px !important">
                  <img src="assets/images/checklist-task-icon.svg" style="height: 32px" />
                </span>
                <p
                  style="padding-left: 6px"
                  class="text-truncate text-sm font-bold text-[#18191C] m-0 leading-[48px]"
                  [ngClass]="{ 'hover:cursor-pointer': !isRemoveEditSaveSharing }"
                  [matTooltip]="task.name"
                >
                  {{ task.name }}
                </p>
              </div>
              <button
                class="m-2 h-8 w-28 rounded"
                [disabled]="isRemoveEditSaveSharing"
                [ngClass]="{ 'bg-[#25508E] text-white hover:cursor-pointer': !isRemoveEditSaveSharing }"
                (click)="$event.stopPropagation(); editTask(task)"
              >
                View
              </button>
            </div>
            }
          </div>
          } @if (suggestion_reminder_count?.length && !hideManageButton) {
          <div
            (click)="createReminder()"
            class="cursor-pointer app__centered-item flex-row text-center h-[38px] bg-[#ebf0fa] rounded mt-2"
            [ngClass]="setZeroMargin ? 'mx-[0px]' : 'mx-[0px]'"
          >
            <img src="assets/images/linked-folder/linked-suggestion.svg" width="18px" height="18px" />
            <span class="app__form--attribute--title font-semibold text-[#18191C] text-[12px] ml-2">
              View Suggestions <span class="font-bold text-[#25508E]">({{ suggestion_reminder_count?.length }})</span>
            </span>
          </div>
          }
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </mat-dialog-content>
</div>
